module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('motivoOcorrencia.titulos.cadastroTitulo'),
      "subTitle": _vm.$t('motivoOcorrencia.titulos.cadastroSubtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.filterPortletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonInitials"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.sigla'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrenceReason.initials),
      expression: "occurrenceReason.initials"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReasonInitials')
    },
    attrs: {
      "type": "text",
      "id": "occurrenceReasonInitials",
      "name": "occurrenceReasonInitials",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.occurrenceReason.initials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrenceReason, "initials", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('occurrenceReasonInitials')),
      expression: "errors.has('occurrenceReasonInitials')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonDescription"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrenceReason.description),
      expression: "occurrenceReason.description"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReasonDescription')
    },
    attrs: {
      "type": "text",
      "id": "occurrenceReasonDescription",
      "name": "occurrenceReasonDescription",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.occurrenceReason.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrenceReason, "description", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('occurrenceReasonDescription', 'required')),
      expression: "errors.firstByRule('occurrenceReasonDescription', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonCategory"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.categoria'))
    }
  }), _c('v-select', {
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReason.category')
    },
    attrs: {
      "options": _vm.categories,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "occurrenceReason.category",
      "id": "occurrenceReasonCategory",
      "name": "occurrenceReasonCategory"
    },
    on: {
      "input": _vm.setOcurrencyCategory
    },
    model: {
      value: (_vm.occurrenceReason.category),
      callback: function($$v) {
        _vm.$set(_vm.occurrenceReason, "category", $$v)
      },
      expression: "occurrenceReason.category"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.salvar'),
      "id": "btnSalvarMotivoDeOcorrencia",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "clickFunction": _vm.back,
      "id": "btnVoltarSalvarMotivoDeOcorrencia",
      "customClass": "secondary"
    }
  })], 1)])])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-758aea92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-758aea92"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/occurrenceReason/new.pug
// module id = 1440
// module chunks = 0